import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, Mic2, Ticket } from 'lucide-react';
export function RecordsPage() {
  return <div className="min-h-screen font-sans" style={{
    backgroundColor: '#0D121D'
  }} data-id="element-268">
      <Header data-id="element-269" />

      <main className="pt-32 pb-24 min-h-screen" data-id="element-270">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-271">
          <a href="/" className="inline-flex items-center text-slate-300 hover:text-white transition-colors mb-12" data-id="element-272">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-273" />
            Back to Home
          </a>

          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-274">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-275">
              Twice Bourne Records
            </h1>
            <p className="text-xl text-slate-300" data-id="element-276">
              Amplifying voices and creating timeless music. Our record label is
              dedicated to discovering and nurturing exceptional talent.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-277">
            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8" data-id="element-278">
              <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-279">
                <Mic2 className="w-7 h-7" data-id="element-280" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-281">
                Music Production
              </h3>
              <p className="text-slate-300 text-lg leading-relaxed" data-id="element-282">
                We produce music and connect various artists with distribution
                networks to maximize their audience reach across all platforms.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8" data-id="element-283">
              <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-284">
                <Ticket className="w-7 h-7" data-id="element-285" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-286">
                Concert Hosting
              </h3>
              <p className="text-slate-300 text-lg leading-relaxed" data-id="element-287">
                We host concerts with artist entourages, providing high-quality
                backstage services and seamless event management for artists.
              </p>
            </div>
          </div>

          <div className="text-center bg-white/5 backdrop-blur rounded-3xl border border-slate-700/50 p-12 max-w-4xl mx-auto" data-id="element-288">
            <h2 className="text-3xl font-bold text-white mb-4" data-id="element-289">
              Ready to amplify your voice?
            </h2>
            <p className="text-slate-300 mb-8 text-lg" data-id="element-290">
              Join our growing roster of talented artists and let us help you
              reach your full potential.
            </p>
            <button className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium rounded-full text-slate-900 bg-white hover:bg-slate-100 transition-colors" data-id="element-291">
              Register as an Artist
            </button>
          </div>
        </div>
      </main>

      <Footer data-id="element-292" />
    </div>;
}